import axios from '../../http'

class XBSelectionCart {
  //xb选品池列表
  getXBSelectionList() {
    const url = `/api/xb/selection/cart/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //xb添加选品池
  postXBAddSelection(data) {
    const url = `/api/xb/selection/cart/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //xb修改选品池数量
  postXBUpdateSelection(data) {
    const url = `/api/xb/selection/cart/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //xb删除选品池
  postXBDelSelection(data) {
    const url = `/api/xb/selection/cart/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //xb提交订单
  postXBConfirmSelection(data) {
    const url = `/api/xb/selection/confirm`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //xb选品单确认页面
  postXBSelectionInfo(data) {
    const url = `/api/xb/selection/info`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //xb选品单列表
  getXBSelectionOrderList(status, searchValue, currentPage) {
    const url = `/api/xb/selection/order/list?status=${status}&searchValue=${searchValue}&currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //xb取消订单
  postXBCancelSelection(data) {
    const url = `/api/xb/selection/order/cancel`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //确认邀约
  postXBConfirmInvitation(data) {
    const url = `/api/xb/selection/order/confirm/invitation`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //直播完成
  postXBFinishLive(data) {
    const url = `/api/xb/selection/finish/live`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default XBSelectionCart;
